<template>
  <div class="tree">
    <div :class="`tree-header ${allowDrag ? 'tree-header_drag' : ''}`">
      <h1>{{$t('message.generics.message.status')}}</h1>
      <h1>{{$t('message.generics.message.name')}}</h1>
      <h1 v-show="gerenciarLocal">{{$t('message.admGenerics.message.edition')}}</h1>
    </div>

    <LocalsNested v-if="list && list.length"
                  :list="list"
                  :allow-drag="allowDrag"
                  @edit="openEditModal"
                  @setLevel="emitSetLevel"
                  @unsetLevel="emitUnsetLevel"
                  @reload="reloadLocaleTableHandler" 
                  @reloadDeviceCount="emitReloadDeviceCount"/>

    <infinite-loading :identifier="infiniteId"
                      @infinite="load">
      <div slot="no-results">{{$t('message.generics.message.noResultsFound')}}</div>
      <div slot="no-more"></div>

    </infinite-loading>

    <AccessPointGroupModal ref="accessPointGroupModal"
                           v-show="false" 
                           v-model="showAccessPointGroupModal"/>
    <LocalsGroupCreationModal ref="localsGroupModal"
                              v-show="false" 
                              v-model="showLocalsGroupCreationModal"/>
    <LocalsCreationModal ref="localsCreationModal"
                         v-show="false" 
                         v-model="showLocalsCreationModal"/>
    <UserDeviceModal ref="userDeviceModal"
                     v-show="false" 
                     v-model="showUserDeviceModal"/>
  </div>
</template>

<script>
    import InfiniteLoading from 'vue-infinite-loading';
    import LocalsNested from '@views/locals/components/LocalsNested';
    import UserDeviceModal from '@views/devices/UserDeviceModal';
    import LocalsCreationModal from "@views/locals/components/LocalsCreationModal";
    import LocalsGroupCreationModal from "@views/locals/components/LocalsGroupCreationModal";
    import AccessPointGroupModal from '@views/locals/components/AccessPointGroupModal';
    import EventBus from '@packages/event-bus'

    export default {
        components: {
            AccessPointGroupModal,
            LocalsGroupCreationModal,
            LocalsCreationModal,
            UserDeviceModal,
            LocalsNested,
            InfiniteLoading
        },


        async mounted() {
            EventBus.$on('RELOAD_LOCALE_TABLE', this.reloadLocaleTableHandler);
            EventBus.$on('SEARCH_LOCALE_TABLE', this.searchLocaleTableHandler);

        },

        beforeDestroy() {
            EventBus.$off('RELOAD_LOCALE_TABLE', this.reloadLocaleTableHandler);
            EventBus.$off('SEARCH_LOCALE_TABLE', this.searchLocaleTableHandler);
        },

        data() {
            return {
                list: [],
                page: 0,
                search: '',
                allowDrag: true,
                showLoadButton: false,
                infiniteId: +new Date(),
                showLocalsGroupCreationModal: false,
                showLocalsCreationModal: false,
                showUserDeviceModal: false,
                showAccessPointGroupModal: false
            }
        },

        mixins: [],

        computed: {
          permissions() {
            return this.$store.state.users.user.permissions;
          },
          gerenciarLocal() {
            return this.permissions['GERENCIAR_LOCAL'];
          }
        },

        methods: {
            emitSetLevel(level) {
                this.$emit('setLevel', level);
            },
            emitUnsetLevel(level) {
                this.$emit('unsetLevel', level);
            },
            emitReloadDeviceCount() {
                this.$emit('reloadDeviceCount');
            },
            reloadLocaleTableHandler() {
                this.page = 0;
                this.list = [];

                this.infiniteId++;
            },
            async searchLocaleTableHandler(search) {
                if(search) {
                    this.allowDrag = false;
                } else {
                    this.allowDrag = true;
                }

                this.search = search;

                this.reloadLocaleTableHandler();
            },
            openEditModal({id, tipo}) {
                if(tipo === 'GRUPO_PONTO_ACESSO') {
                    this.showAccessPointGroupModal = true
                    this.$refs.accessPointGroupModal.edit(id);
                } else if(tipo ==='GRUPO_LOCAL' ) {
                    this.showLocalsGroupCreationModal = true
                    this.$refs.localsGroupModal.edit(id);
                } else if(tipo === 'LOCAL') {
                    this.showLocalsCreationModal = true
                    this.$refs.localsCreationModal.edit(id);
                } else if(tipo === 'APARELHO') {
                    this.showUserDeviceModal = true
                    this.$refs.userDeviceModal.edit(id);
                }
            },
            async load($state) {
                let nextPageList = [];

                if(!this.search) {
                    nextPageList = await this.$api.localeManagement.search({ page: this.page });
                } else {
                    nextPageList = await this.$api.localeManagement.search({ page: this.page, filtro: this.search });
                }

                if(nextPageList.length) {
                    this.page += 1;

                    this.list.push(...nextPageList);

                    if($state) {
                        $state.loaded();
                    }

                } else {
                    if($state) {
                        $state.complete();
                    }
                }
                // console.log("lista", this.list)
            },
        },



    }
</script>

<style scoped lang="scss">
@import "~@variables";

.tree {
  margin-bottom: 30px;

  .tree-header {
    display: flex;
    border-bottom: 1px solid #c8c8c8;
    margin-left: 0;

    h1 {
      padding: 0 24px;
      font-weight: 600;
      font-size: 15px;

      &:last-child {
        margin-left: auto;
      }
    }

    &.tree-header_drag {
      margin-left: 24px;
    }
  }

  .empty-state {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    cursor: pointer;
    height: 55px;
    border-bottom: 1px solid #c8c8c8;
    user-select: none;
  }

  .btn {
    display: block;
    margin: 15px auto;
    color: $primary;
  }
}
</style>
